import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Signup from './views/Signup.vue'
import Signin from './views/Signin.vue'
import Dashboard from './views/Dashboard.vue'
import Register from './views/dashboard/Register.vue'
import Transactions from './views/dashboard/Transactions.vue'
import Elements from './views/dashboard/Elements.vue'

Vue.use(Router);

const appRouter = new Router({
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
    },
    {
      path: '/signin',
      name: 'signin',
      component: Signin,
      redirect: '/signup'
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/register',
      component: Register
    },
    {
      path: '/dashboard/transactions',
      component: Transactions
    },
    {
      path: '/dashboard/payments',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/disputes',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/analysis',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/risk-management',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/reporting',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/schedule',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/notifications',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/virtual-terminal',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/banking',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/contracts',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/features-suite',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/ticketing',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/live-chat',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard/elements',
      component: Elements
    },
  ],
})

export default appRouter
